import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useEffect, createContext, useState, useMemo, useCallback } from 'react';
import useSWR from 'swr';
import { HTTPMethod } from 'http-method-enum';
import { useRouter } from 'next/router';
import * as Sentry from '@sentry/nextjs';
import { StatusCodes } from 'http-status-codes';
import { API_AUTH_STATUS, API_USER } from '@poplar/constants/routes';
import { captureException } from '@yoweb/utils/sentry';
import { fetchJson } from '@yoweb/utils/fetchJson';
import { ApiError, fetcher } from '@yoweb/utils/common';
import { toErrorObject } from '@yoweb/utils/error';
import { negotiateTimezone } from '@yoweb/utils/i18n';
import { getRep } from '@poplar/lib/api/guide';
import { ApiResponseStatus } from '@poplar/lib/api/utils';
import { assertIsString } from '@yoweb/utils/isString';
import { loginEvent } from '@yoweb/utils/analytics/mixpanel';
import { jsx as _jsx } from "react/jsx-runtime";
export var AuthenticationType;

(function (AuthenticationType) {
  AuthenticationType["auth0"] = "auth0";
  AuthenticationType["unauthenticated"] = "unauthenticated";
})(AuthenticationType || (AuthenticationType = {}));

export var WatchAuthFetchResult;

(function (WatchAuthFetchResult) {
  WatchAuthFetchResult[WatchAuthFetchResult["expired"] = 0] = "expired";
})(WatchAuthFetchResult || (WatchAuthFetchResult = {}));

export var UserContext = /*#__PURE__*/createContext(undefined); // eslint-disable-next-line sonarjs/cognitive-complexity

var useCombinedUserState = function useCombinedUserState(initialUser) {
  var _useRouter = useRouter(),
      locale = _useRouter.locale;

  assertIsString(locale);

  var _useState = useState(initialUser),
      user = _useState[0],
      setUser = _useState[1];

  var _useState2 = useState(null),
      rep = _useState2[0],
      setRep = _useState2[1];

  var _useState3 = useState(undefined),
      error = _useState3[0],
      setError = _useState3[1];

  var _useState4 = useState(undefined),
      repError = _useState4[0],
      setRepError = _useState4[1];

  var _useState5 = useState(false),
      forcedExpiration = _useState5[0],
      setForcedExpiration = _useState5[1];

  var _useSWR = useSWR(API_AUTH_STATUS, fetcher, {
    shouldRetryOnError: false,
    focusThrottleInterval: 30000
  }),
      authStatusData = _useSWR.data;

  var fetchUser = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var newUserObj;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return fetchJson(API_USER, {
                method: HTTPMethod.GET,
                headers: {
                  'Cache-Control': 'no-cache'
                }
              });

            case 3:
              newUserObj = _context.sent;

              if (newUserObj.user) {
                setUser(newUserObj.user); // Note: May be the wrong spot for event.  loginEvent here may be problematic
                // since fetchUser is called often and outside of logging in i.e. when refetching user object

                loginEvent(newUserObj.user.userId);
              } // eslint-disable-next-line no-catch-all/no-catch-all


              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              setError(toErrorObject(_context.t0));

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));

    return function fetchUser() {
      return _ref.apply(this, arguments);
    };
  }();

  var fetchRep = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var newRep;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getRep(locale);

            case 2:
              newRep = _context2.sent;

              if (!(newRep.status === ApiResponseStatus.ERROR || !newRep.data)) {
                _context2.next = 5;
                break;
              }

              return _context2.abrupt("return", setRepError(toErrorObject(newRep.error)));

            case 5:
              setRep(newRep.data);

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function fetchRep() {
      return _ref2.apply(this, arguments);
    };
  }();

  var clear = function clear() {
    setUser(undefined);
    setRep(null);
  };

  var refresh = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return Promise.all([fetchUser(), fetchRep()]);

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function refresh() {
      return _ref3.apply(this, arguments);
    };
  }(); // Fetch the user and rep when auth status changes


  useEffect(function () {
    if (!authStatusData) {
      return;
    }

    if (authStatusData.isAuthenticated) {
      void refresh();
    } else {
      setUser(undefined);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [authStatusData]);

  var update = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(data) {
      var payload, updatedUser;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (user) {
                _context4.next = 2;
                break;
              }

              return _context4.abrupt("return");

            case 2:
              payload = {
                locale: locale,
                address: data.userAddress,
                telephoneNumber: {
                  telephoneNumber: data.phoneNumber
                },
                timeZone: data.timeZone
              };
              _context4.next = 5;
              return fetchJson(API_USER, {
                method: HTTPMethod.PATCH,
                body: JSON.stringify(payload)
              });

            case 5:
              updatedUser = _context4.sent;

              if (!updatedUser) {
                _context4.next = 10;
                break;
              }

              setUser(updatedUser);
              loginEvent(updatedUser.userId);
              return _context4.abrupt("return", updatedUser);

            case 10:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function update(_x) {
      return _ref4.apply(this, arguments);
    };
  }();

  useEffect(function () {
    if (error) {
      captureException(error);
    }
  }, [error]);
  useEffect(function () {
    if (user) {
      // Note: intentionally not clearing this state on "no user" so that exceptions that occur on timed out sessions
      // are associated with the last logged in user id
      Sentry.setUser({
        id: user.userId
      });
    }
  }, [user]);
  var timeZone = useMemo(function () {
    return negotiateTimezone(locale, user);
  }, [locale, user]); // use with fetchJson

  var watchAuthFetch = useCallback( /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(fetchRequest) {
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return fetchRequest;

            case 3:
              return _context5.abrupt("return", _context5.sent);

            case 6:
              _context5.prev = 6;
              _context5.t0 = _context5["catch"](0);

              if (!(_context5.t0 && _context5.t0 instanceof ApiError && (_context5.t0.statusCode === StatusCodes.UNAUTHORIZED.valueOf() || _context5.t0.status === StatusCodes.UNAUTHORIZED.valueOf()))) {
                _context5.next = 11;
                break;
              }

              setForcedExpiration(true);
              return _context5.abrupt("return", WatchAuthFetchResult.expired);

            case 11:
              throw _context5.t0;

            case 12:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[0, 6]]);
    }));

    return function (_x2) {
      return _ref5.apply(this, arguments);
    };
  }(), []); // use with safeFetch

  var watchSafeFetch = useCallback( /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(fetchRequest) {
      var result;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return fetchRequest;

            case 2:
              result = _context6.sent;

              if (result.status === ApiResponseStatus.INVALID_AUTH_SESSION) {
                setForcedExpiration(true);
              }

              return _context6.abrupt("return", result);

            case 5:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function (_x3) {
      return _ref6.apply(this, arguments);
    };
  }(), []);
  var commonValues = {
    timeZone: timeZone,
    forcedExpiration: forcedExpiration,
    actions: {
      clear: clear,
      refresh: refresh,
      refreshUser: fetchUser,
      setUser: setUser,
      watchAuthFetch: watchAuthFetch,
      watchSafeFetch: watchSafeFetch
    }
  };

  if (user === undefined) {
    return _objectSpread({
      type: AuthenticationType.unauthenticated,
      isAuthenticated: false,
      profile: undefined,
      rep: null
    }, commonValues);
  }

  if (user && !error && !user.error) {
    return _objectSpread({
      update: update,
      type: AuthenticationType.auth0,
      isAuthenticated: true,
      profile: user,
      error: undefined,
      repError: undefined,
      rep: rep
    }, commonValues);
  }

  return _objectSpread({
    type: AuthenticationType.unauthenticated,
    isAuthenticated: false,
    profile: undefined,
    error: error,
    repError: repError,
    rep: null
  }, commonValues);
};

export var UserProvider = function UserProvider(_ref7) {
  var children = _ref7.children,
      user = _ref7.user;
  var state = useCombinedUserState(user);
  return /*#__PURE__*/_jsx(UserContext.Provider, {
    value: state,
    children: children
  });
};